export const ADD_NOTIFICATION = "ADD_NOTIFICATION";
export const APP_LOAD = "APP_LOAD";
export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const REMOVE_NOTIFICATION = "REMOVE_NOTIFICATION";
export const UPDATE_COMMON = "UPDATE_COMMON";
export const TOKEN_PRESENT = "TOKEN_PRESENT";
